export default __webpack_public_path__ + "e0148ad1b01a6eb73bfcb02203d66a64.jpg";